import React from "react";
import { TextField, Grid, useTheme, Typography, Modal, Backdrop } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {  RTL } from "../../../../components";
import AlertInfo from "components/AlertInfo";
import { Form } from "views/ManageDriver/components";

const EditCompany = (props) => {
  const { open, onClose, title, onAccept,id,reloadFunc, data, ...rest } = props;
  const theme = useTheme(); 

  return (
<>
    <Modal
        open={open}
        style={{Height:'100vh',width:'80%',marginRight:'10%',marginLeft:'10%', display: 'flex',
        justifyContent: 'center',
        alignItems: 'center', }}      
        
        onClose={onClose}
      >
        <div style={{backgroundColor:'white',padding:'2%',width:'65%',  border: "none",
}}>
        <Form onClose={onClose} reloadFunc={reloadFunc} data={data || undefined} id={id} edit={true}/>

        </div>
      </Modal>
 

      {/* <AlertInfo
        fullWidth={true}
        onClose={onClose}
        onAccept={onAccept}
        {...rest}
        maxWidth={"sm"}
        title={props.title}
        open={open}
      >
       <Form edit={true}/>
      </AlertInfo> */}
  </>
  );
};

export default EditCompany;
